module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAnklEQVRo3u2ZwQmAMAxFs2Cn6gqO4hYOFQ8iqPRm8jH1BXJILu0jPEipubtVTgMAAAAAAOA1gNni2elm8fkEODqXQwNrCUBr6+0CkbUEIGsSZy8hxgDRk5AB4MDUDigBcGDkgAIAB6Z2oPwupHSg9y20lq8SZR0ov0qUfdB43ZgFIGO8igTgMwBIjMRIjMRIjMTFHeCHBgAAAADgnwA7h4Ur+GDIDkIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/United-States.png
// module id = 283
// module chunks = 0